var Marionette = require('backbone.marionette');
var $ = require('jquery');
var _ = require('underscore');

module.exports = Marionette.ItemView.extend({
    template: false,

    multiple: true,

    ui: {
        input: 'input',
        select: 'select',
    },

    events: {
        'change @ui.select': 'onSelectChange',
        'change @ui.input': 'onCheckboxChange',
    },

    onRender: function() {
        this.ui.input.hide();
        var select = $('<select>')
            .attr('name', this.$el.attr('data-input-group'))
            .addClass('form-control')
            .prop('multiple', this.getOption('multiple'));

        if (!this.getOption('multiple')) {
            select.append('<option>Select Choice</option>');
        }
        _.each(this.ui.input, function(input) {
            var option = $('<option>')
                .val(input.name)
                .text($(input).attr('data-name'));
            select.append(option);
        });
        this.$el.append(select);
        this.$('select').select2(_.extend({ width: '100%', closeOnSelect: !this.getOption('multiple') }));
    },

    onCheckboxChange: function() {
        var val = null;

        if (this.getOption('multiple')) {
            val = [];
            _.each(this.ui.input, function(input) {
                if (input.checked) {
                    val.push(input.name);
                }
            });
        } else {
            _.each(this.ui.input, function(input) {
                if (input.checked) {
                    val = input.name;
                }
            });
        }

        this.$('select')
            .val(val)
            .change();
    },

    onSelectChange: function() {
        this.ui.input.prop('checked', false);
        var selectedEls = this.$('select').find('option:selected');

        _.each(
            selectedEls,
            function(selectedEl) {
                var input = _.findWhere(this.ui.input, { name: selectedEl.value });
                $(input).prop('checked', true);
            }.bind(this)
        );
    },
});
